import axios from 'axios'
import authHeader from './auth-header'
import router from '../plugins/router'
import store from '../plugins/vuex'
import GlobalDataService from './GlobalDataService'

export default function setup() {

  axios.interceptors.request.use(
    (config) => {

      // If we have an auth token, but it's expired, then delete the token,
      // close any modals that are open, redirect to the login page, and cancel
      // this HTTP request
      const userExpirationDtStr = localStorage.getItem('user_expiration_dt')
      const user_expiration_dt = userExpirationDtStr === null ? null : parseInt(userExpirationDtStr, 10)
      if (user_expiration_dt) {
        const now = Math.floor(new Date().getTime() / 1000) // get the current Unix timestamp in seconds
        if (user_expiration_dt <= now) {
          console.log('token expired')
          const to = router.currentRoute.value.fullPath
          GlobalDataService.purge()
          store.dispatch('auth/logout')
            .then(() => {
              // this won't include any querystring vars set by QuerySyncer,
              // because it bypasses vue-router, and therefore it isn't aware
              // of them
              router.push({name: 'login', query: {to}})
            })
          throw new axios.Cancel('Login token is expired');
        }
      }

      config.headers = authHeader()
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    });

}
